import Provisions from './Provisions';

export default Provisions;
